/*
 * @Author: zyy
 * @Date: 2022-04-01 13:31:50
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-08-29 09:46:03
 * @Description: default
 */
/*
 * @Author: zyy
 * @Date: 2022-04-01 10:08:35
 * @LastEditors: zyy
 * @LastEditTime: 2022-04-01 11:25:52
 * @Description: default
 */
import Axios from "axios";
import Qs from 'qs'
import shopRequest from '@/io/shopRequest'
export default {
    // 添加文章
    add(
        title,
        category_id,
        source,
        community_ids,
        cover_image,
        body,
    ) {
        return Axios.post('/tsjy/api/admin/news/news/add', {
            title,
            category_id,
            source,
            community_ids,
            cover_image,
            body,
        })
    },

    // 文章列表
    list(
        title,
        category_id,
        time,
        current_page,
    ) {
        return Axios.get('/tsjy/api/admin/news/news/list', {
            params: {
                title,
                category_id,
                start_time: time ? time[0] : undefined,
                end_time: time ? time[1] : undefined,
                current_page
            },
            paramsSerializer(params) {
                return Qs.stringify(params);
            }
        })
    },
    // 文章详情
    detail(id) {
        return Axios.get(`/tsjy/api/admin/news/news/detail/${id}`)
    },
    // 更新
    update(
        id,
        title,
        category_id,
        source,
        community_ids,
        cover_image,
        body
    ) {
        return Axios.post(`/tsjy/api/admin/news/news/update/${id}`, {
            title,
            category_id,
            source,
            community_ids,
            cover_image,
            body
        })
    },
    // 删除
    delete(id) {
        return Axios.post(`/tsjy/api/admin/news/news/delete/${id}`)
    },
    // 设置状态
    status(id) {
        return Axios.post(`/tsjy/api/admin/news/news/setStatus/${id}`)
    }

}